
import './Contact.css';
import React, { useState, useEffect, } from 'react'
import {FaHome} from 'react-icons/fa';
import { IoCall } from "react-icons/io5";
import {HiMail} from "react-icons/hi";
import image from "../Assets/bg.jpg";
import  Footer  from "../Footer.js";
import { Helmet } from 'react-helmet';



function Contact() {

    const [button,setButton] = useState(true);


   

const showButton = () =>{
  if(window.innerWidth <= 960){
    setButton(false);
  }
  else{
    setButton(true);
  }
}

useEffect(()=>{
  showButton();
},[]);
  window.addEventListener('resize',showButton);



  return (
    <div style={{backgroundColor:'#f9f5ef',}}>
      <Helmet>
      <title>Contact Us - Brown Profiles</title>
<meta name="description" content="If you have any questions about Brown Profiles® or would like us to be involved with your next project, please contact us via email or phone." />
      </Helmet>
         <title>Brown Profiles | CONTACT US </title>
       <div style={{paddingTop:150,display:'flex',flexDirection:'column',alignItems:'center',paddingBottom:50}}>
       <text style={{fontSize:'8vh',fontFamily:'Cormorant'}}>CONTACT</text>
        <text style={{width:'60vw',color:'#1d1c18',textAlign:'center',color:'#C19A5B'}}>If you have any questions about Brown Profiles® or would like us to be involved with your next project, please contact us via email or phone.</text>
      <div style={{display:'flex',flexDirection:button?'row':'column',paddingTop:120}}>
      <div style={{display:'flex',flexDirection:'column',color:'grey',fontSize:12,fontFamily:'Montserrat',alignItems:'center'}}>
      <text style={{color:'black',paddingBottom:10}}>GENERAL</text>
      <a href='tel:+919030777222'  style={{color:"grey"}}>+91 9030777222</a>    
      <a href='tel:+917337077746' style={{color:"grey"}} >+91 7337077746</a>    
      <a href="mailto:info@brownprofiles.com"  style={{color:"grey"}}>info@brownprofiles.com</a>
    
     <a className='underline-hover-effect' style={{marginTop:25,fontWeight:'bold',  color:'#C19A5B'}} href='https://www.instagram.com/brown.profiles/' target="_blank">INSTAGRAM</a>
      </div>
      <div style={{display:'flex',flexDirection:'column',color:'grey',fontSize:12,fontFamily:'Montserrat',paddingLeft:button?100:0,alignItems:'center'}}>
      <text style={{color:'black',paddingBottom:10,paddingTop:button?0:25}}>ADDRESS</text>
      <text>Viswakarma ML Furniture</text>
      <text>Plot No. CFC 1/A, Road No. 10, Kattedan,</text>
      <text>Industrial Area, Hyderabad, T.S. 500077</text>
      <a className='underline-hover-effect' style={{marginTop:25,fontWeight:'bold',  color:'#C19A5B'}} href='https://goo.gl/maps/K7TSFT3FKZAZaHuA9' target="_blank">VIEW ON MAPS</a>

      </div>
      </div>
    </div>

    <div>
        <img alt='Fluted wooden wall panelling' src={image} style={{height:button?'90vh':'30vh',margin:'4%',width:'92%',backgroundPosition:'center',backgroundSize:'cover'}}/>
    </div>

  <Footer/>
    </div>
  );
}

export default Contact;